// extracted by css-extract-rspack-plugin
export default {"cls1":"AiSummary-cls1__i0","cls2":"AiSummary-cls2_4Yx AiSummary-cls1__i0"};